namespace GeniuzPOS.ReportMasterData {
    export class Report_1302Columns {
        static columnsKey = 'ReportMasterData.Report_1302';
    }
}
